import React from 'react'
import { Avatar, Box, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { getUsuarioFromSession } from '../../utils/permisos'

const pageTitles = {
  '/': 'Inicio',
  '/aplicaciones': 'Aplicaciones disponibles',
  '/accesos-recientes': 'Accesos recientes',
  '/tareas': 'Tareas pendientes',
  '/admin': 'Panel administrador',
  '/admin/aplicaciones': 'Aplicaciones',
  '/admin/integraciones': 'Integraciones y servicios',
  '/admin/procesos-hoy': 'Procesos hoy',
  '/admin/procesos-error': 'Procesos con error',
  '/admin/proximas-ejecuciones': 'Próximas ejecuciones',
  '/admin/usuarios': 'Usuarios',
  '/admin/roles': 'Roles y permisos',
  '/admin/auditoria': 'Auditoría',
}

export const Topbar = ({ onMenuClick, sidebarCollapsed, sidebarOpen, mobile, session }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const currentPageTitle = pageTitles[pathname.replace(/\/+$/, '') || '/'] || 'Clasol Suite Apps'
  const { logout } = useAuth()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const usuario = getUsuarioFromSession(session)
  const nombreUsuario = usuario?.displayName || usuario?.username || 'Usuario'
  const inicial = nombreUsuario.trim()[0]?.toUpperCase() || 'U'

  const handleLogout = async () => {
    setAnchorEl(null)
    await logout()
    navigate('/login', { replace: true })
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }

    navigate('/')
  }

  const menuTitle = mobile
    ? (sidebarOpen ? 'Cerrar menu' : 'Abrir menu')
    : (sidebarCollapsed ? 'Mostrar menu lateral' : 'Ocultar menu lateral')

  return (
    <Box component="header" className="suite-topbar">
      <Box className="suite-topbar-left">
        <Box className="suite-topbar-navigation">
          <IconButton onClick={onMenuClick} className="suite-icon-button" title={menuTitle}>
            <MenuRoundedIcon />
          </IconButton>
          <IconButton onClick={handleBack} className="suite-icon-button" title="Volver atras">
            <ArrowBackRoundedIcon />
          </IconButton>
        </Box>
        <Typography className="suite-breadcrumb">{currentPageTitle}</Typography>
      </Box>

      <Box className="suite-topbar-actions">
        <Box className="suite-user-menu" onClick={(event) => setAnchorEl(event.currentTarget)}>
          <Avatar className="suite-user-avatar">{inicial}</Avatar>
          <Typography className="suite-user-name">{nombreUsuario}</Typography>
          <ExpandMoreRoundedIcon sx={{ fontSize: 19 }} />
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem onClick={handleLogout}>
            <LogoutRoundedIcon fontSize="small" sx={{ mr: 1 }} />
            Cerrar sesión
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}
